import axios from "axios";
import store from "../store";

const request = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 30000
});

request.interceptors.request.use(config => {
  const accessToken = store.getters.accessToken;
  config.headers = config.headers || {};
  config.headers.Accept = "application/json";
  config.headers.platform = "PC";
  config.headers.SystemUpdate = 3;
  if (accessToken) {
    config.headers.Authorization = `WLXS ${accessToken}`;
  }
  return config;
});

request.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
);

export default request;
